import React, { useEffect, useMemo } from 'react';
import RouteConstants from '../../constants/routeConstants';
import { Paper, Box } from '@mui/material';
import { useState, Downgraded } from '@hookstate/core';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';
import DataList from '../Schedule/dataList/dataList';
import moment from 'moment';
import Helper from '../../utility/helper';
import { ScheduleDataService } from '../../services/ScheduleService';
// import PreviewReport from '../Schedule/previewReport';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
import {
    FULL_PERMISSION,
    ScheduleUserType,
    VIEW_PERMISSION,
} from '../../constants/Constant';
import '../Schedule/pdfReport.css';
import PDFDownload from '../Schedule/pdfDownload';
import axios from 'axios';
import APIURLConstants from '../../config/config';
import { saveAs } from 'file-saver';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { useAgentState } from '../../hookState/AgentState';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
    cardContent: {
        '&:last-child': {
            paddingBottom: '16px',
        },
    },
}));

const UserActivities = () => {
    const agentState = useAgentState();
    const loading = useState(false);
    const classes = useStyles();
    const activityList = useState([]);
    const dates = useState([]);
    const [search, setSearch] = React.useState('');
    const originalData = useState([]);
    const userInfo = useState({});
    const eventData = useState({});
    // const exportPDF = useState(false);
    const selectedScheduleReport = useState();
    const [modPermission, setModPermission] = React.useState(null);
    const [userActivityPDFLoader, setUserActivityPDFLoader] = React.useState(false);
    const [openBackdrop, setBackDrop] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
     useEffect(() => {
         console.log(openBackdrop);
        const guserInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');

        userInfo.set(guserInfo);
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
        }
        // added check for showing user view schedule when admin is acting as agent
        if ((gAgentInfo && agentState.visible.value) && !(Helper.isEventAdmin(gAgentInfo) || Helper.isAdminUser(gAgentInfo))) {
            setModPermission(VIEW_PERMISSION);
        }
        else if (!(gAgentInfo && agentState.visible.value) && Helper.isAdminUser(guserInfo) || Helper.isEventAdmin(guserInfo)) {
            setModPermission(FULL_PERMISSION);
        }
        // if (Helper.isAdminUser(guserInfo) || Helper.isEventAdmin(guserInfo)) {
        //     setModPermission(FULL_PERMISSION);
        // } 
        else {
            setModPermission(VIEW_PERMISSION);
        }
        fetchActivities(agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.get().userID);
    }, []);
    const handleOnChange = (event) => {
        let str = event.target.value;
        let value = str.replace(/^\s+/g, '');
        let list = originalData.attach(Downgraded).get();
        setSearch(value);
        getFormatedData(list, value);
    };
    function getDates(startDate, endDate) {
        const dates = [];
        let currentDate = startDate;
        const addDays = function (days) {
            const date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        };
        while (currentDate <= endDate) {
            dates.push(moment(currentDate).format('MM/DD/YYYY'));
            currentDate = addDays.call(currentDate, 1);
        }
        return dates;
    }
    const getFormatedData = (data, search) => {
        let modifyList = [];
        if (search.length > 0) {
            data.forEach((item) => {
                let data = item;
                let keys = Object.keys(data);
                keys.forEach((key) => {
                    if (
                        typeof data[key] === 'string' &&
                        data[key].toLowerCase().indexOf(search.toLowerCase()) >
                        -1
                    ) {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                });
            });
        } else {
            modifyList = data;
        }
        let activityData = [];
        let activityDates = [];
        if (modifyList.length > 0) {
            modifyList.map((item) => {
                let startDate =
                    item.startDateTime !== null
                        ? moment(item.startDateTime).format('MM/DD/YYYY')
                        : null;
                let endDate = null; // item.endDateTime !== null ? moment(item.endDateTime).format('MM/DD/YYYY') : null;
                let range = [];
                if (startDate !== null && endDate !== null) {
                    range = getDates(moment(startDate), moment(endDate));
                } else if (startDate !== null && endDate === null) {
                    range = [startDate];
                } else if (startDate === null && endDate !== null) {
                    range = [endDate];
                } else {
                    range = ['TBD'];
                }
                var onlyStartTime = item.startDateTime && item.startDateTime.substring(item.startDateTime.length - 8); 
                var onlyEndTime = item.endDateTime && item.endDateTime.substring(item.endDateTime.length - 8); 

                activityDates = [...activityDates, ...range];
                activityData.push({
                    actualData: item,
                    row: [
                        {
                            label: 'Start Time',
                            key: onlyStartTime === "00:00:00" ? "" : 'startTime',
                            startTime:  moment(item.startDateTime).format(
                                        'hh:mm a'
                                    ),
                            width: '0.1',
                            inColumn: true,
                        },
                        {
                            label: 'End Time',
                            key: onlyEndTime === "00:00:00" ? "" : 'endTime',
                            endTime: moment(item.endDateTime).format('hh:mm a'), 
                            width: '0.1',
                            inColumn: true,
                        },
                        {
                            label: 'Name',
                            key: 'activityName',
                            activityName: item.activityName,
                            showLabel: false,
                            width: '0.50',
                            inColumn: true,
                            notes: item.notes,
                            showNote: true,
                        },
                        {
                            label: 'Location',
                            key: 'location',
                            location: item.location,
                            // showLabel: false,
                            width: '0.15',
                            inColumn: true,
                            // alignRight: true
                        },
                        {
                            label: 'Attire',
                            key: 'attire',
                            attire: item.attire,
                            // showLabel: false,
                            width: '0.15',
                            inColumn: true,
                            // alignRight: true
                        },
                    ],

                    selected: false,
                });
                loading.set(false);
            });
        } else {
            activityData = [];
            activityDates = [];
            loading.set(false);
        }

        dates.set([...new Set(activityDates)]);
        activityList.set(activityData);
    };
    const fetchActivities = async (userId) => {
        loading.set(true);
        let result = await ScheduleDataService.getActivityList(
            eventData.get().eventID,
            userId
        );
        // console.log("result", result);
        // let notPublishedData = [];
        // result.data && result.data.map((item) =>
        // {
        //     if (item.isPublished)
        //     {
        //         publishedData.push(item)
        //     }
        // })
        if (eventData.attach(Downgraded).get().isPublished) {
            let scheduleData = [];
            result.data.map((item) => {
                if (item.userType !== ScheduleUserType[1]) {
                    scheduleData.push({ ...item });
                }
            });
            originalData.set(scheduleData);
            getFormatedData(scheduleData, search);
        } else {
            let scheduleData = [];
            result.data.map((item) => {
                if (item.userType !== ScheduleUserType[1]) {
                    if (item.isRowPublished) {
                        scheduleData.push({ ...item });
                    }
                }
            });
            originalData.set(scheduleData);
            getFormatedData(scheduleData, search);
            // originalData.set(notPublishedData);
            // getFormatedData(notPublishedData, search);
        }
    };
    const callExport = () => {
        const selected = activityList
            .get()
            .filter((user) => user.selected === true);
        const allList = activityList
            .get()
            .filter((user) => user.selected === false);

        if (selected.length === 0) {
            generateExcelReport(allList);
        } else {
            generateExcelReport(selected);
        }
    };

    const generateExcelReport = (result) => {
        let activityDates = [];
        result.map((item) => {
            let startDate =
                item.actualData.startDateTime !== null
                    ? moment(item.actualData.startDateTime).format('MM/DD/YYYY')
                    : null;
            let endDate = null; //item.actualData.endDateTime !== null ? moment(item.actualData.endDateTime).format('MM/DD/YYYY') : null;
            let range = [];
            if (startDate !== null && endDate !== null) {
                range = getDates(moment(startDate), moment(endDate));
            } else if (startDate !== null && endDate === null) {
                range = [startDate];
            } else if (startDate === null && endDate !== null) {
                range = [endDate];
            }
            activityDates = [...activityDates, ...range];
        });
        let uniqueDates = [...new Set(activityDates)];
        uniqueDates = uniqueDates.sort((a, b) => moment(a) - moment(b));
        // console.log("date", uniqueDates);
        let allData = [];
        let data = [];

        uniqueDates.forEach((el) => {
            let list = [...result];
            allData = list.filter((x) => {
                if (x.actualData.startDateTime !== null) {
                    // && x.actualData.endDateTime !== null
                    if (
                        moment(el).format('MM/DD/YYY') ===
                        moment(x.actualData.startDateTime).format('MM/DD/YYY')
                    )
                        //&& moment(el).format('MM/DD/YYY') <= moment(x.actualData.endDateTime).format('MM/DD/YYY')
                        return x;
                } else if (
                    x.actualData.startDateTime === null &&
                    x.actualData.endDateTime !== null
                ) {
                    if (
                        moment(el).format('MM/DD/YYY') ==
                        moment(x.actualData.endDateTime).format('MM/DD/YYY')
                    )
                        return x;
                }
                // else if (x.actualData.startDateTime !== null && x.actualData.endDateTime === null) {
                //     if (moment(el).format('MM/DD/YYY') == moment(x.actualData.startDateTime).format('MM/DD/YYY'))
                //         return x;
                // }
            });

            allData.forEach((row) => {
                // console.log("row",row);
                data.push({
                    StartDate: Helper.FormatDate(row.actualData.startDateTime),
                    StartDatetime: moment(row.actualData.startDateTime).format( 'hh:mm:ss') === '12:00:00' ? '' :  Helper.FormatTime(
                        row.actualData.startDateTime
                    ),
                    EndDatetime: moment(row.actualData.endDateTime).format( 'hh:mm:ss') === '12:00:00' ? '' :  Helper.FormatTime(row.actualData.endDateTime),
                    Activityname: row.actualData.activityName,
                    Location: row.actualData.location,
                    attire: row.actualData.attire,
                    notes: row.actualData.notes,
                });
                if(row.actualData.subActivities && row.actualData.subActivities.length > 0){
                    row.actualData.subActivities.map((value) => {
                        data.push({
                            StartDate: '',
                            StartDatetime: moment(value.startDateTime).format( 'hh:mm:ss') === '12:00:00' ? '' : Helper.FormatTime(
                                value.startDateTime
                            ),
                            // endDate: Helper.FormatDate(value.endDateTime),
                            EndDatetime: moment(value.endDateTime).format( 'hh:mm:ss') === '12:00:00' ? '' : Helper.FormatTime(value.endDateTime),
                            Activityname: value.subActivityName,
                            Location: '',
                            attire: '',
                            notes: value.notes,
                            tags: ''
                        });
                    }) 
                }
            });
            
        });
        // console.log("filter", data);
        const header = {
            StartDate: 'Date',
            StartDatetime: 'Start',
            EndDatetime: 'End',
            Activityname: 'ActivityName',
            Location: 'Location',
            attire: 'Attire',
            notes: 'Notes',
        };

        data.unshift(header);
        Helper.downloadReport(data, `Schedule-Report`);
    };
    // const exportToPDF = async () => {
    //     const mainContainerList =
    //         document.querySelectorAll("[id^='divToPrint']");
    //     for (let x = 0; x < mainContainerList.length; x++) {
    //         //let arrcontentId = mainContainerList[x].id.split('_');
    //         //let gameId = arrcontentId && arrcontentId.length > 0 ? arrcontentId[1] : '';
    //         let printableArea = mainContainerList[x];
    //         printableArea.style.display = 'block';
    //         var pdf = new jsPDF('l', 'pt', 'letter', false);

    //         pdf.internal.scaleFactor = 2.25;
    //         // get all elements with page-break classes to add page break
    //         var printableIds = printableArea.querySelectorAll('.page-break');

    //         for (let i = 0; i < printableIds.length; i++) {
    //             const content = printableIds[i];
    //             await html2canvas(content, {
    //                 useCORS: true,
    //                 allowTaint: true,
    //             }).then((canvas) => {
    //                 getCanvasPdfPages(pdf, canvas);
    //             });
    //             if (i < printableIds.length - 1) pdf.addPage();
    //         }

    //         printableArea.style.display = 'none';
    //         //setOpenBackDrop(false);

    //         let fileName = mainContainerList[x].id.slice(11) + '.pdf';

    //         // let gameData = gameList.find(g => g.gameId === gameId);
    //         // if (gameData) {
    //         //     fileName = 'PlayOffDeepDive_' + gameData.awayTeamAbr + '@' + gameData.homeTeamAbr + '-' + Helper.FormatDate(gameData.gameDate) + '.pdf'
    //         // }
    //         pdf.save(fileName);
    //     }
    // };
    // const getCanvasPdfPages = (pdf, canvas) => {
    //     var contentWidth = canvas.width;
    //     var contentHeight = canvas.height;

    //     //a4 paper size [595.28, 841.89] in pts. convert it into px by dividing (72 / 96)
    //     var paperWidth = 750; /// (72 / 96); 595.28
    //     var paperHeight = 590; /// (72 / 96); 841.89
    //     //One page pdf shows the canvas height generated by html pages.
    //     var pageHeight = (contentWidth / paperWidth) * paperHeight;
    //     //html page height without pdf generation
    //     var leftHeight = contentHeight;
    //     //Page offset
    //     var position = 0; //default value 0 -added 10 for top margin
    //     //a4 paper size [595.28, 841.89], html page generated canvas in pdf picture width
    //     var imgWidth = paperWidth - 40;
    //     var imgHeight = (paperWidth / contentWidth) * contentHeight;
    //     var pageData = canvas.toDataURL('image/png', 1.0);
    //     //There are two heights to distinguish, one is the actual height of the html page, and the page height of the generated pdf (841.89)
    //     //When the content does not exceed the range of pdf page display, there is no need to paginate
    //     if (leftHeight < pageHeight) {
    //         pdf.addImage(pageData, 'JPEG', 40, 40, imgWidth, imgHeight);
    //     } else {
    //         while (leftHeight > 0) {
    //             pdf.addImage(
    //                 pageData,
    //                 'JPEG',
    //                 40,
    //                 position,
    //                 imgWidth,
    //                 imgHeight
    //             );
    //             leftHeight -= pageHeight;
    //             position -= paperHeight;
    //             //Avoid adding blank pages
    //             if (leftHeight > 0) {
    //                 pdf.addPage();
    //             }
    //         }
    //     }
    // };
    const handleSelectedExportToPDF = () => {
        // exportPDF.set(true);
        // setBackDrop(false);
        // console.log(openBackdrop);
        //console.log('pdf export')
        //let selectedParticipant = overallParticipants.get().filter(i => i.selected);
        //console.log('selectedParticipant', selectedParticipant)
        //let arrReport = [];
    //   console.log("userInfo.userID",userInfo.userID); 
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        setUserActivityPDFLoader(true)
        axios.get(window.location.origin+"/"+APIURLConstants.DOWNLOAD_INDIVIDUAL_SCHEDULE(
            eventData.attach(Downgraded).get().eventID,
            agentConnection && gAgentInfo ? gAgentInfo.userID : userInfo.attach(Downgraded).get().userID,
            ScheduleUserType[0],
            false
        ), { headers:{'Authorization':`Bearer ${Helper.getStorage('accessToken')}`}, responseType: 'blob' })
        .then((res) =>
        {
            saveAs.saveAs(res.data, `${agentConnection && gAgentInfo ? gAgentInfo.lastName : userInfo.attach(Downgraded).get().lastName}, ${agentConnection && gAgentInfo ? gAgentInfo.firstName : userInfo.attach(Downgraded).get().firstName}`+".pdf")
            setUserActivityPDFLoader(false)
        })
        .catch((err) =>
        {
            setUserActivityPDFLoader(false);
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please try after some time.',
            });
            console.log(err);
        });
        // let newData = []
        
        // let data = {};
        // let activities = activityList
        //     .get()
        //     .filter((x) => x.actualData.startDateTime != null);
        // data['participantName'] = `${userInfo.attach(Downgraded).get().lastName
        //     }, ${userInfo.attach(Downgraded).get().firstName}`;
        // data['eventName'] = eventData.attach(Downgraded).get()?.eventName;
        // data['activities'] = activities;
        // // console.log('export pdf data', data)
        // //arrReport.push(data)
        // newData.push(data)
        // // console.log("newData",newData);
        // selectedScheduleReport.set(newData);
        //selectedScheduleReport.set(arrReport)
        // setTimeout(() => { 
            // setUserActivityPDFLoader(false)
            // exportToPDF();
        // }, 1000);
    };
    const selectedReport = (value) => {
        // console.log('value', value);
        selectedScheduleReport.set(value);
    };

    const pdfDownload = useMemo(() =>
    {
        return (
            <PDFDownload
                selectedScheduleReport={selectedScheduleReport
                    .attach(Downgraded)
                    .get()}
                setSelectedScheduleReport={selectedReport}
                open={setBackDrop}
            />
        );
    }, [selectedScheduleReport.get()]);
    return (
        <>
            {loading.get() ? (
                <Box
                    sx={
                        loading.get()
                            ? { paddingTop: '20%', paddingBottom: '20%' }
                            : ''
                    }
                    className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none' }}>
                    <DataList
                        data={activityList.attach(Downgraded).get()}
                        dates={dates.attach(Downgraded).get()}
                        title={''}
                        showSendAll={false}
                        showEdit={false}
                        showSearch={true}
                        search={search}
                        showPdfExport={true}
                        callPdfExport={handleSelectedExportToPDF}
                        hideAdd={true}
                        showExport={true}
                        hideDelete={true}
                        callExport={callExport}
                        handleOnChange={handleOnChange}
                        searchLabel={'Search'}
                        modPermission={modPermission}
                        userActivityPDFLoader={userActivityPDFLoader}
                     />
                    {/* {exportPDF.get() && (
                        <div
                            id={
                                'divToPrint_' +
                                selectedScheduleReport.attach(Downgraded).get()
                                    .participantName
                            }>
                            <PreviewReport
                                exportToPDF
                                data={selectedScheduleReport
                                    .attach(Downgraded)
                                    .get()}
                            />
                        </div>
                    )} */}
                </Paper>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {pdfDownload}
        </>
    );
};
export default {
    routeProps: {
        path: RouteConstants.USER_ACTIVITIES,
        component: UserActivities,
    },
    name: 'UserActivities',
};
